import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.7803 7.28033C20.0732 6.98744 20.0732 6.51256 19.7803 6.21967C19.4874 5.92678 19.0126 5.92678 18.7197 6.21967L9.25 15.6893L4.78033 11.2197C4.48744 10.9268 4.01256 10.9268 3.71967 11.2197C3.42678 11.5126 3.42678 11.9874 3.71967 12.2803L8.71967 17.2803C8.75628 17.3169 8.79574 17.349 8.83732 17.3764C9.12844 17.5686 9.52405 17.5366 9.78033 17.2803L19.7803 7.28033Z",
		fill: "currentColor"
	})
});
export { SvgIconCheckmark as ReactComponent };
